export { default } from './ComplectationStorageContentMobile';
